import React from 'react';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import List from './List';

const breadcrumbs = [{ label: 'Safety Projects', isActive: true }];

const SafetyProjects = () => (
  <PageContainer heading="SAFETY PROJECTS" breadcrumbs={breadcrumbs}>
    <SafetyNav />
    <List />
  </PageContainer>
);

export default SafetyProjects;
